module.exports = __webpack_public_path__ + "static/media/arquitet-negocios.8eb72bc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/valentines_day/arquitet-negocios.png
// module id = 316
// module chunks = 0